import people from './people';

export default {
	people: people
};



// WEBPACK FOOTER //
// ./src/script/model/index.js